import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
          language === 'en'
            ? 'text-white shadow-soft'
            : 'text-gray-600 hover:bg-green-50'
        }`}
        style={language === 'en' ? {backgroundColor: '#05472A'} : {}}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('ar')}
        className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
          language === 'ar'
            ? 'text-white shadow-soft'
            : 'text-gray-600 hover:bg-green-50'
        }`}
        style={language === 'ar' ? {backgroundColor: '#05472A'} : {}}
      >
        عربي
      </button>
    </div>
  );
};

export default LanguageSwitcher;
